export default __webpack_public_path__ + "9472c4fef1eab1fb2361ca163c6c81fa.png";